import PropTypes from 'prop-types';
import React from 'react';

const BOLabelItem = ({data}) => {
  return (
    <span className={`list-tags__item osim-label ${data.IsSpecial ? 'osim-label--highlight' : 'osim-label--default'} `}>{data.Name}</span>
  );
};

BOLabelItem.propTypes = {
  data: PropTypes.object
};

export default BOLabelItem;
